// export const BASE_URL = "http://localhost:5000/";
// export const SECRET_KEY = "AlifCattleFarm2024";
export const BASE_URL = "/alifadmin/api/";
export const SECRET_KEY = "AlifCattleFarm2024";




/************Dummy keep commented**************/
//export const BASE_URL = "http://localhost:5000";
// export const BASE_URL = "http://208.109.231.39:5000/";
//export const BASE_URL = "http://localhost:5000";
export const STRIPE_public_KEY = "pk_live_51RDnUjKK5NeIwomRUmrFkXaWgVbAXok2qZ3xmdp0cI2VHvXXLzYIfFSiaybn3oP2c9vJ8TbN12Y1XD8oTEfXnCp000rla8LUfp"
export const BOP_CHECKOUT = "https://ap-gateway.mastercard.com/static/checkout/checkout.min.js";